import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import AppBar from 'material-ui/AppBar';


class Success extends Component {
    
    render() { 
        
        return ( 
            <MuiThemeProvider>
                <React.Fragment>
                    <AppBar title="Success"/>
                    <h1>Thankyou For Submitting Your Details!!</h1>
                    <p>You Will Receive Further Notifications Through Your Email-Id</p>
                </React.Fragment>
            </MuiThemeProvider>
         )
    }
}
 
export default Success;